

document.addEventListener( 'DOMContentLoaded', function() {
  /**
   * Replace <img> tags with SVG content dynamically using jQuery.
   *
   *
   * This function targets all <img> tags with the class 'svg' and replaces them.
   * It preserves the ID, class, and size attributes of the original <img> tag.
   */
  const imgSvgs = /** @type {NodeListOf<HTMLImageElement>} */( document.querySelectorAll( 'img.svg' ) );
  imgSvgs.forEach( function( img ) {
    const id = img.id;
    const classList = img.classList.toString();
    const url = img.src;
    const ext = url.split( '.' ).pop();
    if ( ext !== 'svg' ) return;

    fetch( url ).then( async ( res ) => {
      const svgString = await res.text();
      const svg = textToHTML( svgString );
      if ( !svg ) return;

      if ( id ) svg.id = id;
      if ( classList ) svg.setAttribute( 'class', classList );
      svg.classList.add( 'replace-svg' );
      const height = svg.getAttribute( 'height' );
      const width = svg.getAttribute( 'width' );
      if ( !svg.getAttribute( 'viewBox' ) && height && width ) {
        svg.setAttribute( 'viewBox', `0 0 ${height} ${width}` );
      }

      img.replaceWith( svg );
    } ).catch( e => {
      console.warn( e );
    } );
  } );
} );


// Talk.to close on click away funcitonality
jQuery( function() {
  // Checks for the talk.to iframe widget and adds a listener to close the chat window when clicking out of it.
  const checkingForIframe = setInterval( addLiveChatClickAway, 1000 );
  const iframeCheckerLimit = setTimeout( () => {
    if ( checkingForIframe ) clearInterval( checkingForIframe );
  }, 10000 );

  function addLiveChatClickAway() {
    const chatIframes = document.querySelectorAll( 'iframe[title="chat widget"]' );
    const chatWindow = chatIframes[1];
    const chatOpener = chatIframes[0];
    if ( !chatWindow || !chatOpener ) return;
    clearInterval( checkingForIframe );
    clearTimeout( iframeCheckerLimit );
    const chatDoc = chatOpener.contentDocument;
    const chatOpenerButton = chatDoc.querySelector( 'button' );
    document.addEventListener( 'click', () => {
      if ( chatWindow.style.display === "block" ) {
        chatOpenerButton.click();
      }
    } );
    document.removeEventListener( 'click', addLiveChatClickAway );
  }
} );



document.addEventListener( 'DOMContentLoaded', function() {
  // Add a fade for images that are lazy loaded in
  for ( image of document.querySelectorAll( 'img[loading=lazy]' ) ) {
    image.addEventListener( 'load', e => {
      e.currentTarget.classList.remove( 'image-is-loading' );
      e.currentTarget.animate( {
        opacity: [0, 1]
      }, 400 );
    }, {
      once: true
    } );
    // Only hide if the images are able to trigger the load event
    if ( !image.complete ) {
      image.classList.add( 'image-is-loading' );
    }
  };
} );